import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Scale, FileText, X, Send, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
export function PlayerRightsSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const response = await fetch('https://formsubmit.co/ajax/fgsukraine@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          _subject: `Звернення від ${formData.name}`,
          _captcha: 'false'
        })
      });
      if (response.ok) {
        setStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          description: ''
        });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    if (status === 'success') {
      setStatus('idle');
    }
  };
  return <>
      <section className="py-20 bg-[#F5F0E8]" data-id="element-439">
        <div className="container mx-auto px-4" data-id="element-440">
          <div className="text-center mb-16" data-id="element-441">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-442">
              Права гравців важливі
            </h2>
            <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full mb-6" data-id="element-443" />
            <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-444">
              Знання своїх прав — це перший крок до захисту. Ми надаємо юридичну
              підтримку та консультації.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-445">
            {/* Left Card */}
            <div className="bg-white p-8 md:p-10 rounded-xl shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow" data-id="element-446">
              <div className="w-14 h-14 bg-[#0A5E5C]/10 rounded-full flex items-center justify-center mb-6" data-id="element-447">
                <Scale className="w-8 h-8 text-[#0A5E5C]" data-id="element-448" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-449">
                Знайте свої права
              </h3>
              <ul className="space-y-3 mb-8 text-gray-600 flex-grow" data-id="element-450">
                <li className="flex items-start gap-2" data-id="element-451">
                  <span className="text-[#D4A843] font-bold" data-id="element-452">•</span>
                  Право на чесну гру та прозорі правила
                </li>
                <li className="flex items-start gap-2" data-id="element-453">
                  <span className="text-[#D4A843] font-bold" data-id="element-454">•</span>
                  Право на своєчасну виплату виграшів
                </li>
                <li className="flex items-start gap-2" data-id="element-455">
                  <span className="text-[#D4A843] font-bold" data-id="element-456">•</span>
                  Право на захист персональних даних
                </li>
                <li className="flex items-start gap-2" data-id="element-457">
                  <span className="text-[#D4A843] font-bold" data-id="element-458">•</span>
                  Право на самообмеження
                </li>
              </ul>
              <Button variant="primary" data-id="element-459">Дізнатися більше</Button>
            </div>

            {/* Right Card */}
            <div className="bg-white p-8 md:p-10 rounded-xl shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow" data-id="element-460">
              <div className="w-14 h-14 bg-[#D4A843]/10 rounded-full flex items-center justify-center mb-6" data-id="element-461">
                <FileText className="w-8 h-8 text-[#D4A843]" data-id="element-462" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-463">
                Подати звернення
              </h3>
              <p className="text-gray-600 mb-8 leading-relaxed flex-grow" data-id="element-464">
                Якщо Ви зіштовхнулися з порушенням Ваших прав в сфері азартних
                ігор, Ви можете подати звернення через наш сайт
              </p>
              <Button variant="secondary" onClick={() => setIsModalOpen(true)} data-id="element-465">
                Подати звернення
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Modal Overlay */}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-466">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-467" />

          {/* Modal Content */}
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-468">
            {/* Header */}
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-469">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-470">
                Подати звернення
              </h3>
              <button onClick={closeModal} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-471">
                <X className="w-5 h-5" data-id="element-472" />
              </button>
            </div>

            <div className="p-6" data-id="element-473">
              {status === 'success' ? <div className="text-center py-8" data-id="element-474">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-475">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-476" />
                  </div>
                  <h4 className="text-xl font-serif font-bold text-[#0A5E5C] mb-3" data-id="element-477">
                    Дякуємо за звернення!
                  </h4>
                  <p className="text-gray-600 mb-6" data-id="element-478">
                    Ми отримали ваше звернення і зв'яжемося з вами найближчим
                    часом.
                  </p>
                  <Button variant="outline" onClick={closeModal} data-id="element-479">
                    Закрити
                  </Button>
                </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-480">
                  <p className="text-gray-600 text-sm mb-2" data-id="element-481">
                    Заповніть форму нижче, і наша команда розгляне ваше
                    звернення.
                  </p>

                  <div className="space-y-1.5" data-id="element-482">
                    <label htmlFor="modal-name" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-483">
                      Ім'я та Прізвище
                    </label>
                    <input type="text" id="modal-name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="Ваше ім'я" data-id="element-484" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-485">
                    <div className="space-y-1.5" data-id="element-486">
                      <label htmlFor="modal-email" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-487">
                        Email
                      </label>
                      <input type="email" id="modal-email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="email@example.com" data-id="element-488" />
                    </div>

                    <div className="space-y-1.5" data-id="element-489">
                      <label htmlFor="modal-phone" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-490">
                        Телефон
                      </label>
                      <input type="tel" id="modal-phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="+38 (0XX) XXX-XX-XX" data-id="element-491" />
                    </div>
                  </div>

                  <div className="space-y-1.5" data-id="element-492">
                    <label htmlFor="modal-description" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-493">
                      Опис ситуації
                    </label>
                    <textarea id="modal-description" name="description" rows={4} required value={formData.description} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all resize-none" placeholder="Опишіть детально, що сталося..." data-id="element-494"></textarea>
                  </div>

                  {status === 'error' && <div className="flex items-center gap-2 text-red-600 bg-red-50 p-3 rounded-lg border border-red-100" data-id="element-495">
                      <AlertCircle className="w-5 h-5 flex-shrink-0" data-id="element-496" />
                      <p className="text-sm" data-id="element-497">
                        Виникла помилка. Будь ласка, спробуйте ще раз.
                      </p>
                    </div>}

                  <Button type="submit" variant="secondary" size="lg" className="w-full flex items-center justify-center gap-2" disabled={status === 'submitting'} data-id="element-498">
                    {status === 'submitting' ? <>
                        <Loader2 className="w-5 h-5 animate-spin" data-id="element-499" />
                        Відправка...
                      </> : <>
                        <Send className="w-5 h-5" data-id="element-500" />
                        Надіслати звернення
                      </>}
                  </Button>

                  <p className="text-xs text-center text-gray-500" data-id="element-501">
                    Натискаючи кнопку, ви погоджуєтесь на обробку персональних
                    даних
                  </p>
                </form>}
            </div>
          </div>
        </div>}
    </>;
}